type FeatureToggle = {
    isEnable: boolean;
    [key: string]: FeatureToggle | string | boolean;
};

//  You can add nested features as mentioned there. So it enables you to toggle the features keeping parent active and nested ones disable.
//  Please Note: when you are adding a feature to this json, just follow the format and add this prefix, "feature_". ex: feature_abc
//  For nested properties format like this. if feature_abc, nested one will be feature_abc_xyz

// export const feature_toggle: { [key: string]: FeatureToggle } = {
//     feature_abc: {
//         isEnable: true,
//         feature_abc_xyz: {
//             isEnable: false,
//         }
//     }
// };

// Somewhere in your code, when you start to writing a feature you should use this feature toggle. Think you're writing
// ABC feature and in your code you can maintain it this way.
// feature_toggle.feature_abc.isEnable && <ABC/>
// feature_toggle.feature_abc_xyz.isEnable && <XYZ/>


export const feature_toggle: { [key: string]: FeatureToggle } = {
    onboardingForms: { isEnable: false },
    googleTagManager: { isEnable: true }
};